import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import HomepageButton from '../../HomepageButton';
import './PlayAndEarn.css';

class PlayAndEarn extends Component {
  render() {
    return (
      <div className="play-and-earn-wrapper">
        <div className="play-and-earn-panel">
          <div className="play-and-earn-sub-title">Play and Earn</div>
          <div className="play-and-earn-title">
            Don't let all of the fun pass you by!
          </div>
          <div className="play-and-earn-content">
            Play online games and earn Sapphires for great rewards.
          </div>
          <Link to="slots">
            <HomepageButton title="Explore Games" />
          </Link>
        </div>
      </div>
    );
  }
}

export default PlayAndEarn;
